import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../../chunks/tslib.es6.js";
import { property as s } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as e } from "../../core/accessorSupport/decorators/subclass.js";
import r from "./VisualVariable.js";
import o from "./support/OpacityStop.js";

var _i;

var p = _i = /*#__PURE__*/function (_r) {
  _inherits(i, _r);

  var _super = _createSuper(i);

  function i(t) {
    var _this;

    _classCallCheck(this, i);

    _this = _super.call(this, t), _this.type = "opacity", _this.normalizationField = null;
    return _this;
  }

  _createClass(i, [{
    key: "cache",
    get: function get() {
      return {
        ipData: this._interpolateData(),
        hasExpression: !!this.valueExpression,
        compiledFunc: null
      };
    }
  }, {
    key: "stops",
    set: function set(t) {
      t && Array.isArray(t) && (t = t.filter(function (t) {
        return !!t;
      })).sort(function (t, s) {
        return t.value - s.value;
      }), this._set("stops", t);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _i({
        field: this.field,
        normalizationField: this.normalizationField,
        valueExpression: this.valueExpression,
        valueExpressionTitle: this.valueExpressionTitle,
        stops: this.stops && this.stops.map(function (t) {
          return t.clone();
        }),
        legendOptions: this.legendOptions && this.legendOptions.clone()
      });
    }
  }, {
    key: "getAttributeHash",
    value: function getAttributeHash() {
      return "".concat(_get(_getPrototypeOf(i.prototype), "getAttributeHash", this).call(this), "-").concat(this.normalizationField);
    }
  }, {
    key: "_interpolateData",
    value: function _interpolateData() {
      return this.stops && this.stops.map(function (t) {
        return t.value || 0;
      });
    }
  }]);

  return i;
}(r);

t([s({
  readOnly: !0
})], p.prototype, "cache", null), t([s({
  type: ["opacity"],
  json: {
    type: ["transparencyInfo"]
  }
})], p.prototype, "type", void 0), t([s({
  type: String,
  json: {
    write: !0
  }
})], p.prototype, "normalizationField", void 0), t([s({
  type: [o],
  json: {
    write: !0
  }
})], p.prototype, "stops", null), p = _i = t([e("esri.renderers.visualVariables.OpacityVariable")], p);
var a = p;
export { a as default };